import React from 'react';
import { generateUUID } from 'utils';
import Cookies from 'universal-cookie';
import { GDPRBanner } from '@ppn/common-components';
import { pclnPrivacyPolicyLink, euCountryCodes } from '../../constants';

const CookieBanner = () => {
    const id = generateUUID();
    const cookies = new Cookies();
    const showBanner =
        typeof cookies.get('customer_consent') === 'undefined' && euCountryCodes.includes(cookies.get('locale_country'));

    const handleClose = () => {
        const expDate = new Date();
        //  set expiry date for 30 days in the future
        expDate.setTime(expDate.getTime() + 30 * 24 * 60 * 60 * 1000);
        cookies.set('customer_consent', true, {
            path: '/',
            expires: expDate
        });
        const container = document.getElementById(id);
        container.removeChild(container.firstChild);
    };

    return (
        <div id={id} className="cookieBannerContainer">
            <GDPRBanner show={showBanner} termsURL={pclnPrivacyPolicyLink} handleClose={handleClose} />
        </div>
    );
};

export default CookieBanner;
